import 'jquery-validation';
import 'magnific-popup';

$.validator.addMethod('customEmail',
  function (value) {
    // eslint-disable-next-line no-useless-escape
    return /^([a-zA-Z0-9_.\-+])+\@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/.test(value);
  }
);

$.validator.addMethod('checkMaskPhone', function (value) {
  return /\+\d{1} \(\d{3}\) \d{3}-\d{2}-\d{2}/g.test(value);
});

$.validator.addClassRules({
  'js-valid-phone': {
    checkMaskPhone: true
  },
  'js-valid-email': {
    customEmail: true
  }
});

// Init validation
$('form').each(function () {
  $(this).validate();
});